<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset" @onChange="onSearchItemChange"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="day" slot-scope="params">
        <div v-if="params.params.day && params.params.day.length>0">
          <el-tag v-for="(t,index) in params.params.day" :key="index">{{ t }}</el-tag>
        </div>
        <span v-else>-</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "StaffEscortAttendance",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'escortwork',
      breadcrumb: [
        { name: "考勤管理" },
        { name: "押运出勤" },
      ],
      formInline: {
        month: ''
      },
      formCtrl: [
        {
          label: "月份",
          keyName: "month",
          placeholder: "请选择月份",
          type: "month",
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "押运员",
          keyName: "driver",
          placeholder: "请填写押运员姓名",
          type: "text",
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "name", label: "押运员姓名" },
        { prop: "day", label: "缺勤日期", slot:'day' },
        { prop: "workday", label: "实际出勤天数"},
        { prop: "nowday", label: "应出勤天数" },
        //{ prop: "month", label: "当前月份" },
        { prop: "ewage", label: "预计工资", align:'right', className:'pr30'},
        { prop: "emoney", label: "基础工资", align:'right', className:'pr30'},
      ],
      baseParams: ['month'],
    };
  },
  methods: {},
  created() {
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    this.getList();
  },
};
</script>
<style lang="less" scoped>
/deep/ .fillet .el-form--inline .el-form-item:first-child {
  margin-right: 20px;
}
/deep/ .fillet .el-form--inline .el-form-item:first-child {
    margin-right: 0px;
    padding-right: 80px;
    position: relative;
    &::after {
      position: absolute;
      content: "";
      right: 40px;
      top: 6px;
      width: 1px;
      height: 28px;
      overflow: hidden;
      background-color: #EBEDF0;
    }  
}

.el-tag {
  width: 22px;
  height: 22px;
  line-height: 23px;
  padding: 0;
  overflow: hidden;
  margin: 0 2.5px;
  vertical-align:middle;
  font-size: 13px;
  color: #fff;
  border: 0;
  border-radius: 22px;
  background-color: #F56C6C;
}

/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}

</style>